module.exports = __webpack_public_path__ + "img/extwarning.d147bf9d.svg";